import classnames from 'classnames'
import React, { PureComponent } from 'react'
import styled from 'react-emotion'

import InlineCta from '~/components/InlineCta'
import RoundedCta from '~/components/RoundedCta'

import css from './banner.module.scss'

const cx = classnames.bind(css)

const Root = ({ children, ...rest }) => (
  <div className={cx(css.Banner)} {...rest}>
    {children}
  </div>
)

const Content = 'div'

const P = 'p'

const CloseButton = 'button'

interface Props {
  innerRef: (node: HTMLElement | null) => void
  onClose: () => void
  onChangePreferences: () => void
  onAcceptAll: () => void
  content: React.ReactNode
  acceptButton: React.ReactNode
  manageButton: React.ReactNode
  refuseButton: React.ReactNode
  backgroundColor: string
  textColor: string
}

export default class Banner extends PureComponent<Props> {
  static displayName = 'Banner'

  render() {
    const {
      innerRef,
      onClose,
      onChangePreferences,
      onAcceptAll,
      content,
      acceptButton,
      manageButton,
      refuseButton,
    } = this.props

    return (
      <Root ref={innerRef}>
        <div className={css.bannerText}>{content}</div>
        <div className={css.bannerCtas}>
          <RoundedCta
            className={css.bannerCta}
            theme="tertiary"
            title="Manage Cookies"
            aria-label="Manage Cookies"
            onClick={onChangePreferences}>
            {manageButton}
          </RoundedCta>
          <RoundedCta
            className={css.bannerCta}
            title="Accept Cookies"
            aria-label="Accept Cookies"
            onClick={onAcceptAll}>
            {acceptButton}
          </RoundedCta>
          <InlineCta
            className={css.bannerCta}
            title="Close Cookies"
            aria-label="Close Cookies"
            theme="primary"
            onClick={onClose}>
            {refuseButton}
          </InlineCta>
        </div>
      </Root>
    )
  }
}
